export const initialConflictAlertOptions = {
  background: true,
  bright: 80,
  font: 2,
  border: true,
};
